import { C } from "../tokens";

interface Props {
  value: boolean;
  onChange: (v: boolean) => void;
  size?: "sm" | "md";
  disabled?: boolean;
}

export function Toggle({ value, onChange, size = "sm", disabled }: Props) {
  const w = size === "md" ? 32 : 26;
  const h = size === "md" ? 18 : 14;
  const knob = h - 4;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      disabled={disabled}
      onClick={() => !disabled && onChange(!value)}
      style={{
        width: w, height: h,
        borderRadius: h,
        background: value ? C.blue : C.surfaceMid,
        border: `1px solid ${value ? C.blue : C.border}`,
        position: "relative",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: "background 0.2s, border-color 0.2s",
        padding: 0,
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 1, left: value ? w - knob - 3 : 1,
          width: knob, height: knob,
          borderRadius: "50%",
          background: "#fff",
          transition: "left 0.2s",
          boxShadow: value ? `0 0 8px rgba(255,255,255,0.35)` : "none",
        }}
      />
    </button>
  );
}
